import Header from "./Header";
import { Outlet } from "react-router-dom";

const Layout = () => {
	return (
		<>
			<header>
				<Header />
			</header>

			<main>
				<Outlet />
			</main>

			<hr />

			<footer className="d-flex justify-content-center py-5">
				&copy; Eğitim Bilimleri Pursaklar Spor Kulübü
			</footer>
		</>
	);
};

export default Layout;
